import React from 'react';
import LocationPageTemplate from './LocationPageTemplate';

export default function RichardsonPage() {
  return (
    <LocationPageTemplate
      city="Richardson"
      slug="richardson"
      neighborhoods="From Canyon Creek to the Telecom Corridor, we maintain irrigation for Richardson homes and offices."
      localCopy={[
        "Richardson has some of the oldest established irrigation systems in North Texas — many homes still run original 1970s and 80s mainlines that need careful diagnosis before any repair. We handle vintage Toro, Champion, and early Rain Bird systems alongside modern smart controllers.",
        "Many Richardson commercial properties along the Telecom Corridor depend on functioning irrigation for property values and tenant retention. We provide quarterly inspections, fast emergency response, and detailed reporting for property managers and HOAs.",
        "Richardson requires a backflow preventer on every irrigation system. AAA Irrigation installs new backflows, coordinates the annual testing, and files certifications directly with the City of Richardson so your system stays compliant without you tracking deadlines.",
      ]}
      reviewQuote="Showed up on time, diagnosed the issue in under ten minutes, and had us back up that afternoon. Very fair pricing for a system as old as ours."
      reviewAuthor="David L. — Richardson, TX"
    />
  );
}
